import React, { Component, Fragment } from "react";
import Navbar from "../partials/Navbar";
import Sidebar from "../partials/Sidebar";
import Footer from "../partials/Footer";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
  withRouter,
} from "react-router-dom";
import ReactDatatable from "@ashvin27/react-datatable";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import axios from "axios";
import { addDepositCash } from "../../actions/contestActions";
import {} from "react-router-dom";
import { toast, Toaster } from "react-hot-toast";
import Moment from "moment";
import * as myConstList from "../../BaseUrl";
import Loading from "../layout/Loading";
const configToken = {
  headers: {
    Authorization: "Bearer " + `${localStorage.getItem("jwtToken")}`,
  },
};
const baseUrl = myConstList.baseUrl;
const toastStyles = {
  style: {
    borderRadius: "10px",
    background: "#fff",
    color: "#000",
  },
  errors: {},
};
class Ledger extends Component {
  constructor(props) {
    super(props);
    this.state = {
      records: [],
      winningamount: "",
      isRedeemModal: false,
      attachment: "",
      transactionId: "",
      amount: "",
      logo: "",
      cashWalletBalance: 0,
      cashWinningBalance: 0,
      errors: {},
      errorAttachment: "",
      errorTransactionId: "",
      errorAmount: "",
      urltemp: "",
      disabledButton: false,
      stripePayment: false,
      loadingProcess: false,
      themeSet: "",
      withdrawalFromDtail: {},
      transfrableAmount: 0,
      totalDeposit: 0,
      poolContributionTotal: 0,
      totalWinningAmount: 0,
      totalWithdrawnAmount: 0,
      totalTdsDeduct: 0,
      tdsDeductlist: [],
      widhdrawalFundsRecords: [],
    };

    this.columns = [
      {
        key: "date",
        text: "Date",
        className: "upcase",
        align: "left",
        sortable: true,
        cell: (record) => {
          return <Fragment>{Moment(record.date).format("lll")}</Fragment>;
        },
      },
      {
        key: "txStatus",
        text: "Transaction Type",
        className: "upcase",
        align: "left",
        sortable: true,
        cell: (record) => {
          if (
            record.transType == "CREDIT" &&
            record.txStatus == "winning-cash"
          ) {
            return <Fragment>Winning Credit</Fragment>;
          } else if (
            record.transType == "CREDIT" &&
            record.txStatus == "cash-wallet"
          ) {
            return <Fragment>Received from you</Fragment>;
          } else if (
            record.transType == "DEBIT" &&
            record.txStatus == "withdrawal-cash"
          ) {
            return <Fragment>Withdrawn Out of Deposit</Fragment>;
          } else if (
            record.transType == "DEBIT" &&
            record.txStatus == "withdrawal-winning"
          ) {
            return <Fragment>Withdrawn Out of Winning</Fragment>;
          } else if (
            record.transType == "DEBIT" &&
            record.txStatus == "tdsDeduct"
          ) {
            return <Fragment>TDS on Winning Credit withdrawal</Fragment>;
          }
        },
      },
      {
        key: "amount",
        text: "Amount",
        className: "upcase",
        align: "left",
        sortable: true,
        cell: (record) => {
          return <Fragment>₹ {record.amount}</Fragment>;
        },
      },
      {
        key: "tx_id",
        text: "Transaction Id",
        className: "upcase",
        align: "left",
        sortable: true,
      },
    ];

    this.config = {
      page_size: 10,
      length_menu: [10, 20, 50],
      filename: "Fund Request List",
      no_data_text: "No user found!",
      button: {
        print: true,
        csv: true,
      },
      language: {
        length_menu: "Show _MENU_ result per page",
        filter: "Filter in records...",
        info: "Showing _START_ to _END_ of _TOTAL_ records",
        pagination: {
          first: "First",
          previous: "Previous",
          next: "Next",
          last: "Last",
        },
      },
      show_length_menu: true,
      show_filter: true,
      show_pagination: true,
      show_info: true,
    };

    this.state = {
      records: [],
      fromDate: "",
      toDate: "",
      particular: "",
      accountRange: "",
    };

    this.getData = this.getData5.bind(this);
  }
  editRecord(record) {
    this.setState({ reject: record.reject, approve: record.approve });
  }
  componentWillReceiveProps(nextProps) {
    // console.log("nextPropsnextProps===========", nextProps);
    if (
      nextProps.contestdata !== undefined &&
      nextProps.contestdata.contest !== undefined &&
      nextProps.contestdata.contest.data !== undefined &&
      nextProps.contestdata.contest.data.message !== undefined &&
      nextProps.contestdata.contest.data.success
    ) {
      this.closeModal();
      toast.success(nextProps.contestdata.contest.data.message, toastStyles);
      this.getData5();
      var urltemp = "";
      if (
        localStorage.getItem("source") !== "" &&
        localStorage.getItem("theme") !== ""
      ) {
        urltemp =
          "?source=" +
          localStorage.getItem("source") +
          "&theme=" +
          localStorage.getItem("theme");
        // console.log("urlStamp==",urltemp);
        this.setState({
          urltemp: urltemp,
          themeSet: localStorage.getItem("theme"),
        });
      }
      setTimeout(() => {
        window.location.href = "/addCash" + urltemp;
      }, 1500);
    }
  }
  componentDidMount() {
    var urltemp = "";
    if (
      localStorage.getItem("source") !== "" &&
      localStorage.getItem("theme") !== ""
    ) {
      urltemp =
        "?source=" +
        localStorage.getItem("source") +
        "&theme=" +
        localStorage.getItem("theme");
      // console.log("urlStamp==",urltemp);
      this.setState({
        urltemp: urltemp,
        themeSet: localStorage.getItem("theme"),
      });
    }
    this.getData5();
  }

  getData5() {
    const { user } = this.props.auth;
    axios
      .post(baseUrl + "api/profile-data", {}, configToken)
      .then((res) => {
        // console.log("profile-data=======",res.data.data);
        this.setState({
          cashWalletBalance: res.data.data.cashWalletBalance,
          cashWinningBalance: res.data.data.winningCash,
        });
      })
      .catch();
    axios
      .post(baseUrl + "api/get-all-transactions", {}, configToken)
      .then((res) => {
        // console.log("recordsrecordsrecords=",res.data);
        this.setState({ records: res.data.data });
      })
      .catch();
  }
  filterData = () => {
    console.log("this.state===", this.state);
    axios
      .post(baseUrl + "api/get-all-transactions", {}, configToken)
      .then((res) => {
        let filteredData = [];
        let data = res.data.data;
        let dataSetFilter = 0;
        if (this.state.fromDate != undefined && this.state.fromDate != "") {
          dataSetFilter = 1;
          filteredData = data.filter((item) => {
            const itemDate = Moment(item.date).format("YYYY-MM-DD");
            return itemDate >= this.state.fromDate;
          });
        } else if (dataSetFilter != 1) {
          filteredData = data;
        }
        if (
          this.state.fromDate != undefined &&
          this.state.fromDate != "" &&
          this.state.toDate != undefined &&
          this.state.toDate != ""
        ) {
          dataSetFilter = 1;
          filteredData = filteredData.filter((item) => {
            const itemDate = Moment(item.date).format("YYYY-MM-DD");
            return (
              itemDate >= this.state.fromDate && itemDate <= this.state.toDate
            );
          });
        } else if (dataSetFilter != 1) {
          filteredData = data;
        }
        if (this.state.particular != undefined && this.state.particular != "") {
          dataSetFilter = 1;
          filteredData = filteredData.filter((item) => {
            const itemDate = item.transType;
            if (this.state.particular == "credit") {
              return itemDate == "CREDIT";
            }
            if (this.state.particular == "debit") {
              return itemDate == "DEBIT";
            }
          });
        } else if (dataSetFilter != 1) {
          filteredData = data;
        }
        if (
          this.state.accountRange != undefined &&
          this.state.accountRange != ""
        ) {
          dataSetFilter = 1;
          filteredData = filteredData.filter((item) => {
            const itemDate = Number(item.amount);
            return itemDate <= Number(this.state.accountRange);
          });
          // console.log(this.state.accountRange,"filteredDatafilteredData=",filteredData);
        } else if (dataSetFilter != 1) {
          filteredData = data;
        }
        this.setState({ records: filteredData });
      })
      .catch();
  };
  onChange = (e) => {
    if (e.target.id === "fromDate") {
      this.setState({
        fromDate: e.target.value,
        errorfromDate: "",
      });
    }
    if (e.target.id === "toDate") {
      this.setState({
        toDate: e.target.value,
        errortoDate: "",
      });
    }
    if (e.target.id === "particular") {
      this.setState({
        particular: e.target.value,
        errorparticular: "",
      });
    }
    if (e.target.id === "accountRange") {
      this.setState({
        accountRange: e.target.value,
        erroraccountRange: "",
      });
    }
  };
  closeModal = () => {
    this.setState({
      isRedeemModal: false,
    });
  };

  stripePaymentmodal = () => {
    this.setState({ stripePayment: true });
  };

  pageChange(pageData) {
    // console.log("OnPageChange", pageData);
  }

  render() {
    const { errors1, loadingProcess } = this.state;
    if (loadingProcess) {
      return <Loading themeSet={this.state.themeSet} />;
    }
    return (
      <>
        <Navbar urlPath={true} symbol={false} />
        <Sidebar />
        <div className="container container2">
          <div className=" padding_d in_page">
            <h1 className="h3 white_box">Ledger</h1>
            <div className="white_box">
              <div className="row">
                <div className="col-md-3 mb-3 form-group ">
                  <label>From </label>
                  <input
                    id="fromDate"
                    type="Date"
                    className="form-control"
                    value={this.state.fromDate}
                    onChange={this.onChange}
                  />
                  <span className="text-danger">
                    {this.state.errorafromDate}
                  </span>
                </div>
                <div className="col-md-3 mb-3">
                  <label>To</label>
                  <input
                    id="toDate"
                    type="Date"
                    className="form-control"
                    value={this.state.toDate}
                    onChange={this.onChange}
                  />
                  <span className="text-danger">{this.state.errortoDate}</span>
                </div>

                <div className="col-md-3">
                  <label htmlFor="virtualFund">Particulars</label>
                  <select
                    id="particular"
                    className="form-control"
                    onChange={this.onChange}
                    value={this.state.particular}
                  >
                    <option value="">Select</option>
                    <option value="credit">Credit</option>
                    <option value="debit">Debit</option>
                  </select>
                  <span className="text-danger"></span>
                </div>

                <div className="col-md-3">
                  <label htmlFor="virtualFund">Amount Range</label>
                  <input
                    id="accountRange"
                    type="number"
                    className="form-control"
                    value={this.state.accountRange}
                    onChange={this.onChange}
                  />
                  <span className="text-danger"></span>
                </div>
                <div className="col-md-3">
                  <a
                    href="#"
                    onClick={this.filterData}
                    className="btn btn_man m-auto ml-auro pl-md-5 pr-md-5"
                  >
                    Search
                  </a>
                </div>
              </div>
            </div>
            <div className="tab-content">
              <div className="white_box">
                <div className="ccrool_table">
                  <ReactDatatable
                    config={this.config}
                    records={this.state.records}
                    columns={this.columns}
                    onPageChange={this.pageChange.bind(this)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
        <Toaster position="bottom-right" reverseOrder={false} />
      </>
    );
  }
}

Ledger.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  addDepositCash: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors,
  contestdata: state.contestdata,
});

export default connect(mapStateToProps, { addDepositCash })(withRouter(Ledger));
